import GenericModal from "../../../../components/Modals/genericModal";
import { DiscardContext } from "../../../../contexts";
import { useContext } from "react";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../translations/translationsConstants";

export default function DiscardDialog() {
    const { discardDialogOpen, setDiscardDialogOpen, discardDocument } = useContext(DiscardContext);
    const { t: tc } = useTranslation([resources.common]);
    const { t: te } = useTranslation([resources.edit]);

    const handleConfirm = () => {
        setDiscardDialogOpen(false);
        discardDocument();
    }

    return (
        <GenericModal
            open={discardDialogOpen}
            setOpen={(value) => setDiscardDialogOpen(value)}
            onConfirm={handleConfirm}
            onCancel={() => setDiscardDialogOpen(false)}
            confirmButtonText={tc(translations.common.ok)}
            cancelButtonText={tc(translations.common.cancel)}
            showCancelButton={true}
            title={te(translations.edit.discard.discardDocument)} >
            <div className="tw-w-full tw-py-4">
                <p className="tw-text-sm tw-font-medium tw-text-gray-900">{te(translations.edit.discard.areYouSureToDiscardDocument)}</p>
            </div>
        </GenericModal>
    )
}